query openSurvey($openSurveyExternalId: String!, $openSurveyAccessCode: String) {
  openSurvey(openSurveyExternalId: $openSurveyExternalId, openSurveyAccessCode: $openSurveyAccessCode) {
    status
    survey {
      id
      name
      questions {
        id
        orderIndex
        showSkipButton
        type {
          name
        }
        question {
          ... on SurveyElementMessage {
            messagesPerLanguage {
              message
              description
              language {
                langISOCode
              }
            }
          }
          ... on SurveyElementQuestionScale {
            ratingOptionLowest
            ratingOptionHighest
            required
            showTextComment
            showLabels
            showDescription
            icon {
              name
            }
            messagesPerLanguage {
              message
              description
              labelBefore
              labelAfter
              language {
                langISOCode
              }
            }
          }
          ... on SurveyElementQuestionText {
            required
            showDescription
            messagesPerLanguage {
              message
              description
              language {
                langISOCode
              }
            }
          }
          ... on SurveyElementQuestionOptions {
            required
            showDescription
            showTextComment
            minSelectedOption
            maxSelectedOption
            messagesPerLanguage {
              message
              description
              language {
                langISOCode
              }
            }
            choices {
              id
              orderIndex
              messagesPerLanguage {
                message
                language {
                  langISOCode
                }
              }
            }
          }
        }
      }
    }
  }
}
